import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ViewModeOption } from '../../../../cross-team-shared/toolbars/layer-settings/layer-view-settings.component';

@Component({
  selector: 'h3-raster-coding-layer-view-settings',
  templateUrl: './raster-coding-layer-view-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RasterCodingLayerViewSettingsComponent {
  viewModeOptions: ViewModeOption[] = [
    { viewMode: 'layers', tooltip: 'Mask' },
    { viewMode: 'all', tooltip: 'Both' },
    { viewMode: 'none', tooltip: 'Image' },
  ];
}
